/**
 * Shop the look — hotspot popovers (compact layout)
 */
(function () {
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  function initSection(section) {
    const hotspots = $$('[data-shop-look-hotspot]', section);
    const popovers = $$('[data-shop-look-popover]', section);
    let activeIndex = null;

    function closePopovers() {
      popovers.forEach((p) => {
        p.hidden = true;
      });
      hotspots.forEach((h) => h.setAttribute('aria-expanded', 'false'));
      activeIndex = null;
    }

    function openPopover(index) {
      closePopovers();
      const pop = popovers.find((p) => p.dataset.hotspotIndex === String(index));
      const btn = hotspots.find((h) => h.dataset.hotspotIndex === String(index));
      if (!pop || !btn) return;
      pop.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      activeIndex = index;
    }

    hotspots.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const idx = btn.dataset.hotspotIndex;
        if (activeIndex === idx) {
          closePopovers();
          return;
        }
        openPopover(idx);
      });
    });

    document.addEventListener('click', (e) => {
      if (!section.contains(e.target)) closePopovers();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closePopovers();
    });
  }

  function boot() {
    $$('[data-shop-the-look]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target?.querySelector?.('[data-shop-the-look]') || e.target;
    if (section?.matches?.('[data-shop-the-look]')) initSection(section);
  });
})();
